import {useEffect, useState} from "react";

import {Config} from "../../components/config";
import Head from "next/head";

import {Loader} from "../../components/common/Loader/Loader";
import {Modal} from "../../components/common/Modal/Modal";
import type {NextPage,} from "next";
import {useRouter} from "next/router";
import {UseMobileAppDialog} from "../../components/common/UseMobileAppDialog";
import {logFirebaseEvent} from "../../helpers/firebase_helper";
import Script from "next/script";
import {isFirefox, isIOS, isSafari} from "react-device-detect";

const Page: NextPage = () => {
    const [isLoaded, setLoaded] = useState(false);
    const [isCapturing, setIsCapturing] = useState(false);
    const [flutterRenderer, setFlutterRenderer] = useState('canvaskit');
    const router = useRouter();
    const rendererQuery = router.query['renderer']

    useEffect(() => {
        if (rendererQuery && (rendererQuery === "html" || rendererQuery === "canvaskit")) {
            setFlutterRenderer(rendererQuery as string);
        } else {
            // const shouldLoadFlutterWithCanvasKit = isIOS || isSafari || isFirefox;
            // setFlutterRenderer(shouldLoadFlutterWithCanvasKit ? "canvaskit" : "html"); //TODO: Temporary making CanvasKit default
        }
        if (!isLoaded) {
            listenMessageFromIFrame();
            setLoaded(true);
        }

        setTimeout(() => {
            logFirebaseEvent("cus_app_downloading",);
        }, 0);
    }, [rendererQuery]);
    let flutterAppSrc = `/web/index.html/?renderer=${flutterRenderer}&stitchMode=${router.query['ref'] == "photo-joiner"}`;
    if (router.query['tab']) {
        flutterAppSrc += `&tab=${router.query['tab']}`;
    }


    function listenMessageFromIFrame() {


        window.addEventListener(
            "message",
            (ev: MessageEvent<{ type: string; value: number }>) => {
                // console.log(ev);
                // if (typeof ev.data !== "object") return;
                // if (!ev.data.type) return;
                // if (ev.data.type !== "button-click") return;
                // if (!ev.data.message) return;
                console.log(ev.data);
                if (ev.data?.type === "cmImageCaptureStarted") {
                    setIsCapturing(true);
                    // setScale(ev.data.value);
                }
                if (ev.data?.type === "cmImageCaptureEnded") {
                    setIsCapturing(false);
                    // setScale(1);
                }

                // this.setState({
                //   message: ev.data.message,
                // });
            }
        );
    }

    return (
        <>
            <style jsx>{`
                body {
                    overflow: hidden;
                    padding: 0;
                }
            `}</style>
            <Head>
                <title>{Config.appNameShort} - Collage Editor</title>
                <link rel="icon" type="image/x-icon" href="/favicon.ico"/>
                <link rel="canonical" href="https://www.photojoiner.com/editor/collage-editor"/>
                <Script
                    src="https://sak.userreport.com/photopix/launcher.js"
                    async
                    id="userreport-launcher-script"
                />
            </Head>
            <div className="grid place-items-center w-screen "></div>

            <div id="editor-main-div">
                <div
                    id="cm-iframe-container w-screen"
                    style={{
                        position: "absolute",
                        width: `100%`,
                        height: "100%",

                    }}
                >
                    <iframe
                        id="cm_iframe"
                        src={flutterAppSrc}
                        width="100%"
                        height="100%"
                        style={{
                            minWidth: `300px`,
                            minHeight: `300px`
                        }}

                        allowFullScreen
                    ></iframe>
                </div>
            </div>

            <Modal isOpen={isCapturing} close={() => {

            }} backgroundScroll={true}>
                <div className="grid place-items-center h-screen w-full ">
                    <div className=" flex flex-row items-center  justify-center">
                        <Loader width={40} height={40}/>

                        <div className=" text-white p-2 font-bold">Saving. . .</div>
                    </div>
                </div>
            </Modal>
            <UseMobileAppDialog/>
        </>
    );
};

export default Page;
